
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsShopTypeGrid extends Serenity.EntityGrid<PsShopTypeRow, any> {
        protected getColumnsKey() { return PsShopTypeColumns.columnsKey; }
        protected getDialogType() { return PsShopTypeDialog; }
        protected getIdProperty() { return PsShopTypeRow.idProperty; }
        protected getInsertPermission() { return PsShopTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return PsShopTypeRow.localTextPrefix; }
        protected getService() { return PsShopTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}